import styled from 'styled-components'

export const VaspSignupWrapper = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.brand};
  background: ${({ theme }) => `linear-gradient(25deg, ${theme.colors.backgroundLite} 65%, ${theme.colors.brand} 130%)`};
`

export const VaspSignupInnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`

export const VaspSignupFormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`

export const VaspSignupFormInnerWrapper = styled.div`
  max-width: 500px;
  width: 100%;
`

export const VaspSignupFormContent = styled.div`
  padding: 30px;
  width: 100%;

  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
  border: 1px solid ${({ theme }) => theme.colors.secondary};
`

export const VaspSignupLogoLink = styled.a`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  & svg {
    width: 150px;
    height: 50px;
    & path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`
export const VaspSignupTitle = styled.h1`
  display: flex;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 30px 0;
`

export const VaspSignupBrandWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`

export const VaspSignupBottomWrapper = styled.div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme }) => theme.colors.background};
`

export const PrivacyPolicyLink = styled.a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme }) => theme.colors.primary};
`

export const VaspSignupFormFooterText = styled.p`
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 0 0;

  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
`

export const VaspSignupFormFooterLink = styled.a`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
`
